import gql from 'graphql-tag';

export const CreateContentMutation = gql`
	mutation CreateContentMutation(
		$subType: ConfluencePageSubType
		$spaceKey: String!
		$parentId: ID
		$title: String
		$status: GraphQLContentStatus!
		$contentSpecificCreateInput: [ContentSpecificCreateInput!]
		$type: String!
	) {
		createContentContextual(
			input: {
				spaceKey: $spaceKey
				parentId: $parentId
				status: $status
				type: $type
				subType: $subType
				title: $title
				contentSpecificCreateInput: $contentSpecificCreateInput
			}
		) {
			id
			space {
				id
				alias
				key
			}
			links {
				editui
				context
			}
			metadata {
				frontend {
					collabService
				}
			}
			subType
		}
	}
`;
